__turbopack_context__.v({
  "accordionSlideOverwrite": "radioCardGroup-module-scss-module__OIcqaa__accordionSlideOverwrite",
  "defaultItem": "radioCardGroup-module-scss-module__OIcqaa__defaultItem",
  "defaultItemInner": "radioCardGroup-module-scss-module__OIcqaa__defaultItemInner",
  "description": "radioCardGroup-module-scss-module__OIcqaa__description",
  "fadeIn": "radioCardGroup-module-scss-module__OIcqaa__fadeIn",
  "fadeOut": "radioCardGroup-module-scss-module__OIcqaa__fadeOut",
  "label": "radioCardGroup-module-scss-module__OIcqaa__label",
  "radioCardGroup": "radioCardGroup-module-scss-module__OIcqaa__radioCardGroup",
  "radioCardGroupItem": "radioCardGroup-module-scss-module__OIcqaa__radioCardGroupItem",
  "scaleIn": "radioCardGroup-module-scss-module__OIcqaa__scaleIn",
  "scaleOut": "radioCardGroup-module-scss-module__OIcqaa__scaleOut",
  "zoomIn": "radioCardGroup-module-scss-module__OIcqaa__zoomIn",
  "zoomOut": "radioCardGroup-module-scss-module__OIcqaa__zoomOut",
});
